// extracted by mini-css-extract-plugin
export default {"form":"JoinTeamModal_form__nWvgv","formGroup":"JoinTeamModal_formGroup__Q4Rpn","select":"JoinTeamModal_select__T-SmI","buttons":"JoinTeamModal_buttons__oVdeN"};